import { Language } from '../enum/language.enum';
import { LOCALE_STORAGE_LANGUAGE } from '../config/constants';

/**
 * Resolves the language to use based on the following priority:
 * 1. localStorage value (if valid for the available languages)
 * 2. Browser language (if valid for the available languages)
 * 3. Fallback to Language.EN
 *
 * Persists the resolved language to localStorage if it differs from the saved value.
 */
export function resolveAndStoreLanguage(availableLanguages: Language[]): Language {
  const savedLang = localStorage.getItem(LOCALE_STORAGE_LANGUAGE);
  const browserLang = navigator.language.split('-')[0] as Language;

  let langToUse: Language;
  if (savedLang && availableLanguages.includes(savedLang as Language)) {
    langToUse = savedLang as Language;
  } else if (availableLanguages.includes(browserLang)) {
    langToUse = browserLang;
    localStorage.setItem(LOCALE_STORAGE_LANGUAGE, langToUse);
  } else {
    langToUse = Language.EN;
    localStorage.setItem(LOCALE_STORAGE_LANGUAGE, langToUse);
  }

  return langToUse;
}
